import { Avatar, Box, CardContent, Grid2 as Grid, Typography } from '@mui/material';

import React from 'react';
import champ_coin from '../../assets/champ_coin.png';
import { useNavigate } from 'react-router-dom';
import ProfileImageBlur from '../../components/profileImageBlur';

// Define the types for a single player
interface Player {
  uid: string;
  defaultAvatarPath?: string;
  isDefault: boolean;
  file_name: string;
  name?: string;
  score: number;
  handle: string;
}

// Define the props type for the component
interface LeaderboardProps {
  leaderboard: Player[];
  isMobile: boolean;
  type: string;
}

const Leaderboard: React.FC<LeaderboardProps> = ({ leaderboard, isMobile, type }) => {
  const navigate = useNavigate();

  return (
    <Grid
      container
      spacing={{ xs: 2, md: 4 }}
      direction="column"
      sx={{ width: '100%', maxWidth: { md: '80%', sm: '95%' }, mt: 3 }}>
      {leaderboard.map((player, index) => (
        <Grid size={12} key={player.uid + index}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              padding: { xs: 1, md: '9px' },
              backgroundColor: 'transparent',
              borderRadius: '25px',
              boxShadow: '0px 8px 60px 0px #0000001A',
              cursor: 'pointer'
            }}>
            <Avatar
              sx={{
                width: isMobile ? 23 : 43,
                height: isMobile ? 23 : 43,
                textAlign: 'center',
                color: '#FFFFFF',
                backdropFilter: 'blur(16px)',
                background: 'rgba(31, 29, 58, 0.8)',
                borderRadius: '50%',
                p: 1,
                mr: 2,
                border: '2px solid rgb(255,255,255,0.7)'
              }}>
              <Typography variant={isMobile ? 'body1' : 'h6'} fontSize={isMobile ? 14 : 24} fontFamily="Somatic">
                {index + 4}
              </Typography>
            </Avatar>

            {/* <Avatar
              src={
                type === 'clans'
                  ? `${process.env.REACT_APP_DEFAULT_AVATAR}/APP/ClanAvatars/medium/${player?.file_name}`
                  : player.isDefault
                    ? `${process.env.REACT_APP_DEFAULT_AVATAR}/APP/UserAvatars/${player?.file_name}`
                    : `${process.env.REACT_APP_DEFAULT_AVATAR}/${player?.uid}/PROFILE/IMAGES/medium/${player?.file_name}`
              }
              alt={player.name}
              sx={{ width: isMobile ? 40 : 65, height: isMobile ? 40 : 65 }}
            /> */}
            {type === 'clans' ? (
              <Avatar
                src={`${process.env.REACT_APP_DEFAULT_AVATAR}/APP/ClanAvatars/medium/${player?.file_name}`}
                alt={player.name}
                sx={{ width: isMobile ? 40 : 65, height: isMobile ? 40 : 65 }}
              />
            ) : (
              <ProfileImageBlur
                imgHeight={isMobile ? '40px' : '65px'}
                imgWidth={isMobile ? '40px' : '65px'}
                defaultAvatar={player.isDefault}
                uid={player?.uid}
                avatar={player?.file_name}
                handle={player.handle}
              />
            )}
            <CardContent sx={{ flex: 1, color: 'transparent' }} onClick={() => navigate(`/user/${player.handle}`)}>
              <Typography
                variant={isMobile ? 'body1' : 'h6'}
                sx={{ color: 'white' }}
                fontSize={isMobile ? 14 : 25}
                fontFamily="Baloo2">
                {player?.name
                  ?.toLowerCase()
                  .split(' ')
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' ') || 'Anonymous'}
              </Typography>
            </CardContent>
            <img src={champ_coin} alt={'champ-coin'} width={isMobile ? 20 : 40} height={isMobile ? 20 : 40} />
            <Typography fontSize={isMobile ? 14 : 25} fontFamily="Somatic" sx={{ color: 'white' }}>
              {Number(player.score).toFixed(2)}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default Leaderboard;
